var _clipPath, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNebius = function SvgNebius(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 96,
    viewBox: "0 0 96 96",
    width: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h96v96h-96z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 96,
    maskUnits: "userSpaceOnUse",
    width: 96,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96 0h-96v96h96z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96 0h-96v96h96z",
    fill: "#daff33"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m46.3331 27.4668 12.243 33.8335c4.0549 9.1563 9.2098 6.3939 9.2098 6.3939 0 4.0685-3.2659 7.8683-8.0338 7.8683-4.7678 0-7.4679-2.9684-9.5229-7.5796l-12.2487-33.8336c-4.0536-8.8496-9.7663-6.0873-9.8787-6.032.0607-.0018.0929-.0018.0929-.0018l.0083 44.5261h-10.0072l-.0083-34.6309c0-9.3288 8.8962-9.8628 9.9143-9.8934.0004-4.068 3.2587-7.8673 8.0321-7.8673 4.7737 0 8.1385 2.5999 10.1992 7.2168zm21.464-4.2986.0082 44.526s10.0072 0 10.0072-9.8951l-.0082-34.6309z",
    fill: "#052b42",
    fillRule: "evenodd"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNebius);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "758766447c6ee8a3fdb0e061315a5690.svg";